import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=3cf8b7c2&scoped=true&"
import script from "./GroupModal.vue?vue&type=script&lang=js&"
export * from "./GroupModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupModal.vue?vue&type=style&index=0&id=3cf8b7c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf8b7c2",
  null
  
)

export default component.exports